import React, { useState } from "react";
import "./coach-landing.css";

/**
 * Calculadora de la landing de entrenadores.
 *
 * ⚠️ ANTES PROMETÍA COMISIONES: un slider de "suscriptores que usan tu código"
 * que multiplicaba por 10 € y titulaba "¿Cuánto puedes generar? · Tu ingreso
 * anual estimado". Eso es falso para un coach: las comisiones son del programa
 * de EMBAJADORES, no del entrenador. La regla es que al coach se le ofrece
 * usar la herramienta gratis y nada más, y que lo único que se menciona de
 * dinero es lo que DEJA DE PAGAR. El arreglo del panel (c658ef26) no llegó
 * hasta aquí, que es la página pública.
 *
 * Ahora el slider lo mueve él con SU gasto real, así que no hace falta inventar
 * lo que cobra la competencia: el número que sale es el suyo.
 */
export default function CoachLandingEarnings() {
  const [mensual, setMensual] = useState(45);
  const anual = mensual * 12;

  return (
    <section className="earnings-section" id="earnings">
      <div className="container">
        <div className="earnings-header">
          <div className="section-tag">Calculadora</div>
          <h2 className="section-title">¿Cuánto te cuesta hoy tu software?</h2>
          <p className="section-subtitle">
            Mueve el slider con lo que pagas al mes. Eso es lo que te ahorras.
          </p>
        </div>
        <div className="earnings-card">
          <div className="earnings-slider-label">Lo que pagas al mes por tu software</div>
          <div className="earnings-slider-value">
            {mensual} <span>€/mes</span>
          </div>
          <input
            type="range"
            min="0"
            max="200"
            value={mensual}
            onChange={(e) => setMensual(parseInt(e.target.value))}
            step="5"
          />
          <div className="earnings-result">
            <div className="earnings-result-label">Al año te estás dejando</div>
            <div className="earnings-result-amount">{anual}€</div>
            <div className="earnings-result-period">Con Wayo son 0 €</div>
          </div>
          <div className="earnings-note">
            *El panel de entrenador de Wayo es gratuito: sin cuota mensual y sin permanencia.
          </div>
        </div>
      </div>
    </section>
  );
}
